import 'picturefill';
import 'lazysizes';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/native-loading/ls.native-loading';

// TODO:
// lazySizes.cfg.nativeLoading = {
// 	setLoadingAttribute: true,
// 	disableListeners: {
// 		scroll: true
// 	}
// };
